<template>
   <!-- ----------------------------------------------------------------------------- -->
   <!-- DatatablesCRUDActions -->
   <!-- ----------------------------------------------------------------------------- -->
   <div>
      <v-list-item-subtitle class="text-wrap">

      </v-list-item-subtitle>
      <div class="mt-4">
         <v-data-table :headers="headers" :items="listitems" sort-by="sequence" class="border" hide-default-footer dense>
         <template v-slot:top>
            <v-toolbar flat color="white">
               <v-toolbar-title>Experience</v-toolbar-title>
               <v-divider class="mx-4" inset vertical></v-divider>
               <v-spacer></v-spacer>
               <v-dialog v-model="dialog" max-width="700px">
               <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
               </template>
               <v-card>
                  <v-card-title>
                     <span class="title">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                     <v-container>
                     <v-row dense>
                        <v-col cols="12" sm="1" md="1">
                           <v-text-field v-model="editedItem.sequence" label="No." dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="11" md="11">
                           <v-text-field v-model="editedItem.position" label="Position" dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                           <v-text-field v-model="editedItem.emporg" label="Employment Organization" dense></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                           <v-menu ref="empdatestartselector" v-model="empdatestartselector" :close-on-content-click="false" :return-value.sync="empdatestartselector" transition="scale-transition" offset-y min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                 <v-text-field v-model="editedItem.empdatestart" label="Date Start" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense clearable></v-text-field>
                              </template>
                              <v-date-picker v-model="editedItem.empdatestart" no-title scrollable>
                                 <v-spacer></v-spacer>
                                 <v-btn text color="primary" @click="empdatestartselector = false">Cancel</v-btn>
                                 <v-btn text color="primary" @click="$refs.empdatestartselector.save(editedItem.empdatestart)">OK</v-btn>
                              </v-date-picker>
                           </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                           <v-menu ref="empdateendselector" v-model="empdateendselector" :close-on-content-click="false" :return-value.sync="empdateendselector" transition="scale-transition" offset-y min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                 <v-text-field v-model="editedItem.empdateend" label="Date End" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense clearable></v-text-field>
                              </template>
                              <v-date-picker v-model="editedItem.empdateend" no-title scrollable>
                                 <v-spacer></v-spacer>
                                 <v-btn text color="primary" @click="empdateendselector = false">Cancel</v-btn>
                                 <v-btn text color="primary" @click="$refs.empdateendselector.save(editedItem.empdateend)">OK</v-btn>
                              </v-date-picker>
                           </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                           <v-text-field v-model="editedItem.totalexp" label="Experience (Years)" dense @focus="calcexp()"></v-text-field>
                        </v-col>
                     </v-row>
                     </v-container>
                  </v-card-text>
                  <v-card-actions>
                     <v-spacer></v-spacer>
                     <v-btn color="primary" @click="close">Cancel</v-btn>
                     <v-btn color="primary" @click="save">Save</v-btn>
                  </v-card-actions>
               </v-card>
               </v-dialog>
            </v-toolbar>
         </template>
         <template v-slot:[`item.sequence`]="{ item }">
            <small>{{ item.sequence }}</small>
         </template>
         <template v-slot:[`item.position`]="{ item }">
            <small>{{ item.position }}</small>
         </template>
         <template v-slot:[`item.emporg`]="{ item }">
            <small>{{ item.emporg }}</small>
         </template>
         <template v-slot:[`item.empdatestart`]="{ item }">
            <small>{{ formatDate(item.empdatestart) }}</small>
         </template>
         <template v-slot:[`item.empdateend`]="{ item }">
            <small>{{ formatDate(item.empdateend) }}</small>
         </template>
         <template v-slot:[`item.totalexp`]="{ item }">
            <small>{{ item.totalexp }}</small>
         </template>
         <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
         </template>
         <template slot="body.append">
            <tr>
               <th></th>
               <th></th>
               <th></th>
               <th></th>
               <th><small><b>Total Exp.</b></small></th>
               <th><small>{{ totalsumexp.toFixed(2) }}</small></th>
               <th></th>
            </tr>
         </template>
         </v-data-table>
         <v-dialog v-model="dlgconfirm" width="400" persistent dark>
            <v-card>
               <v-card-title class="title"><span class="text-white">Confirm you want to delete this?</span></v-card-title>
               <v-card-text>
                  <v-row dense>
                     <v-col cols="12" md="3" sm="3">
                        <small><b>No.</b></small>
                     </v-col>
                     <v-col cols="12" md="9" sm="9">
                        <small>{{ todelete.sequence }}</small>
                     </v-col>
                     <v-col cols="12" md="3" sm="3">
                        <small><b>Position</b></small>
                     </v-col>
                     <v-col cols="12" md="9" sm="9">
                        <small>{{ todelete.position }}</small>
                     </v-col>
                     <v-col cols="12" md="3" sm="3">
                        <small><b>Employment Organization</b></small>
                     </v-col>
                     <v-col cols="12" md="9" sm="9">
                        <small>{{ todelete.emporg }}</small>
                     </v-col>
                     <v-col cols="12" md="3" sm="3">
                        <small><b>Date Start</b></small>
                     </v-col>
                     <v-col cols="12" md="9" sm="9">
                        <small>{{ formatDate(todelete.empdatestart) }}</small>
                     </v-col>
                     <v-col cols="12" md="3" sm="3">
                        <small><b>Date End</b></small>
                     </v-col>
                     <v-col cols="12" md="9" sm="9">
                        <small>{{ formatDate(todelete.empdateend) }}</small>
                     </v-col>
                     <v-col cols="12" md="3" sm="3">
                        <small><b>Experience (Years)</b></small>
                     </v-col>
                     <v-col cols="12" md="9" sm="9">
                        <small>{{ todelete.totalexp }}</small>
                     </v-col>
                  </v-row>
               </v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" dark @click="dodelete(todelete)">
                     Yes
                  </v-btn>
                  <v-btn color="primary" dark @click="dlgconfirm = false">
                     No
                  </v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>
      </div>
   </div>
</template>

<script>
const axios = require('axios')

export default {
   name: "TableEmpExp",

   data: () => ({
      userid: 0,
      focus: false,
      empdatestartselector: false,
      empdateendselector: false,
      dialog: false,
      headers: [
         {
            text: "No.",
            align: "start",
            sortable: true,
            value: "sequence",
         },
         {
            text: "Position",
            sortable: false,
            value: "position"
         },
         { text: "Employment Organization", value: "emporg", sortable: false },
         { text: "Date Start", value: "empdatestart", sortable: false },
         { text: "Date End", value: "empdateend", sortable: false },
         { text: "Experience (Years)", value: "totalexp", sortable: false },
         { text: "Actions", value: "actions", sortable: false }
      ],
      listitems: [],
      totalsumexp: 0,
      submitting: false,
      deleting: false,
      dlgconfirm: false,
      confirmdelete: false,
      uploadfile: null,
      editedIndex: -1,
      editedItem: {
         id: 0,
         sequence: 0,
         position: "",
         emporg: "",
         empdatestart: "",
         empdateend: "",
         totalexp: 0
      },
      todelete: {
         id: 0,
         sequence: 0,
         position: "",
         emporg: "",
         empdatestart: "",
         empdateend: "",
         totalexp: 0
      },
      defaultItem: {
         id: 0,
         sequence: 0,
         position: "",
         emporg: "",
         empdatestart: "",
         empdateend: "",
         totalexp: 0
      }
   }),

   computed: {
      formTitle() {
         return this.editedIndex === -1 ? "Employment Experience: New Item" : "Employment Experience: Edit Item";
      }
   },

   watch: {
      dialog(val) {
         val || this.close();
      },
   },

   mounted() {
      this.$emit('EmpExpMounted')
   },

   methods: {
      calcexp() {
         if (this.editedItem.empdatestart) {
            var totalyears = 0
            var date1 = new Date(this.editedItem.empdatestart)
            var date2 = new Date() // today

            if (this.editedItem.empdateend) {
               date2 = new Date(this.editedItem.empdateend)
            }
            totalyears = ((date2 - date1) / (1000 * 3600 * 24)) / 365
            this.editedItem.totalexp = totalyears.toFixed(2)
         }
      },

      formatDate(e) {
         return this.$moment(new Date(e)).format('DD/MM/YYYY')
      },

      setuserid(pUserID) {
         this.userid = pUserID
         this.initialize()
      },

      initialize() {
         this.$nextTick(() => {
            var targetPath = ''
            this.uploadfile = null
            if (this.userid !== 0) {
               targetPath = '/member/empexp/list/' + this.userid // get id from property
            } else {
               targetPath = '/member/empexp/list' // get id from current login session (server-side)
            }
            axios.get(targetPath)
            .then((resp) => {
               if (resp.data) {
                  var rtn = resp.data
                  if (rtn.status === 'OK') {
                     this.listitems = rtn.data
                     if (this.listitems) {
                        this.totalsumexp = 0
                        this.listitems.forEach(itm => {
                           this.totalsumexp +=  parseFloat(itm.totalexp)
                        })
                        this.$emit('EmpExpStatus', { hasEmployment: this.listitems.length > 0, totalExperience: this.totalsumexp })
                     }
                  } else {
                     console.log(rtn.status + ': ' + rtn.error)
                  }
               }
            })
         })
      },

      editItem(item) {
         this.editedIndex = this.listitems.indexOf(item);
         this.editedItem = Object.assign({}, item);
         this.dialog = true;
      },

      deleteItem(item) {
         this.todelete = item
         this.dlgconfirm = true
      },

      dodelete(item) {
         var targetPath = "/member/empexp/delete"
         var data = {
            id: item.id
         }
         this.dlgconfirm = false
         this.deleting = true
         axios.post(targetPath, data)
         .then((resp) => {
            this.deleting = false
            if (resp.data) {
               var rtn = resp.data
                  if (rtn.status === 'OK') {
                     this.initialize()
                     this.$emit('EmpExpStatus', { hasEmployment: false, totalExperience: 0 })
                  } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      close() {
         this.dialog = false
         setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
         }, 300)
      },

      save() {
         var targetPath = ""
         if (this.editedIndex > -1) {
            targetPath = "/member/empexp/update"
         } else {
            targetPath = "/member/empexp/add"
         }

         var data = new FormData()
         if (this.editedIndex > -1) {
            data.append('id', this.editedItem.id)
         } else {
            data.append('userid', this.userid)
         }
         data.append('sequence', this.editedItem.sequence)
         data.append('position', this.editedItem.position)
         data.append('emporg', this.editedItem.emporg)
         data.append('empdatestart', this.editedItem.empdatestart)
         data.append('empdateend', this.editedItem.empdateend)
         data.append('totalexp', this.editedItem.totalexp)

         this.submitting = true
         axios.post(targetPath, data)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.initialize()
                  this.close()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      }

   }
};
</script>
